export function Section(props) {
  return <section className={props.classSection}>{props.children}</section>;
}
